var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.product && _vm.product.skus && _vm.product.skus.length > 0
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-card-actions",
                    {
                      attrs: {
                        "action-collapse": "",
                        "show-loading": _vm.fetching,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("b-card-title", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("Configurações")) + " "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3306125192
                      ),
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-active-online",
                                      type: _vm.isReadOnly
                                        ? "status-badge"
                                        : "switch",
                                      "badge-type": "yesNo",
                                      label: _vm.$t("Vender no Site?"),
                                    },
                                    model: {
                                      value: _vm.product.activeOnline,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.product,
                                          "activeOnline",
                                          $$v
                                        )
                                      },
                                      expression: "product.activeOnline",
                                    },
                                  }),
                                ],
                                1
                              ),
                              !_vm.isAssetProductType
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "2" } },
                                    [
                                      _c("FormulateInput", {
                                        attrs: {
                                          id: "product-active-echopeja",
                                          type: _vm.isReadOnly
                                            ? "status-badge"
                                            : "switch",
                                          "badge-type": "yesNo",
                                          label: _vm.$t("Vender no echope já?"),
                                        },
                                        model: {
                                          value: _vm.product.activeEchopeai,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.product,
                                              "activeEchopeai",
                                              $$v
                                            )
                                          },
                                          expression: "product.activeEchopeai",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-customer-required",
                                      type: _vm.isReadOnly
                                        ? "status-badge"
                                        : "switch",
                                      "badge-type": "yesNo",
                                      label: _vm.$t("Obriga Cliente?"),
                                      instruction: _vm.$t(
                                        "Quando selecionado, caso este produto esteja na venda, será obrigatório informar os dados do cliente"
                                      ),
                                    },
                                    model: {
                                      value: _vm.product.customerRequired,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.product,
                                          "customerRequired",
                                          $$v
                                        )
                                      },
                                      expression: "product.customerRequired",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-featured",
                                      type: _vm.isReadOnly
                                        ? "status-badge"
                                        : "switch",
                                      "badge-type": "yesNo",
                                      label: _vm.$t("Destacar Produto?"),
                                      instruction: _vm.$t(
                                        "Quando selecionado, o produto será destacado para venda nos canais online"
                                      ),
                                    },
                                    model: {
                                      value: _vm.product.featuredProduct,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.product,
                                          "featuredProduct",
                                          $$v
                                        )
                                      },
                                      expression: "product.featuredProduct",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-group-offers-beer-cooler",
                                      type: _vm.isReadOnly
                                        ? "status-badge"
                                        : "switch",
                                      label: _vm.$t("Oferece Kit Chopeira"),
                                      instruction: _vm.$t(
                                        "Quando habilitado, será oferecido o Kit Chopeira nos pedidos do app/site."
                                      ),
                                    },
                                    model: {
                                      value: _vm.product.offersBeerCooler,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.product,
                                          "offersBeerCooler",
                                          $$v
                                        )
                                      },
                                      expression: "product.offersBeerCooler",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-unitsPerPack",
                                      type: _vm.isReadOnly
                                        ? "label"
                                        : "text-number",
                                      label: _vm.$t("Qtd. embalagem pack"),
                                      instruction: _vm.$t(
                                        "Quantidade que vem na embalagem de pack. Exemplo, para long neck, o pack vem com 6 unidades. Esta é a quantidade utilizada para os múltiplos que serão exibidos no app."
                                      ),
                                      validation: _vm.product.activeB2B
                                        ? "required"
                                        : "",
                                    },
                                    model: {
                                      value: _vm.product.unitsPerPack,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.product,
                                          "unitsPerPack",
                                          $$v
                                        )
                                      },
                                      expression: "product.unitsPerPack",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-items-per-delivery-package",
                                      name: "itemsPerDeliveryPackage",
                                      type: _vm.isReadOnly ? "label" : "number",
                                      min: "1",
                                      max: "9999",
                                      step: "1",
                                      validation:
                                        "optional|number|min:1|max:9999",
                                      "validation-messages": {
                                        number: _vm.$t(
                                          "PRODUCT.VALIDATION_ERROR.ITEMS_PER_DELIVERY_PACKAGE_OUT_OF_RANGE"
                                        ),
                                        min: _vm.$t(
                                          "PRODUCT.VALIDATION_ERROR.ITEMS_PER_DELIVERY_PACKAGE_OUT_OF_RANGE"
                                        ),
                                        max: _vm.$t(
                                          "PRODUCT.VALIDATION_ERROR.ITEMS_PER_DELIVERY_PACKAGE_OUT_OF_RANGE"
                                        ),
                                      },
                                      label: _vm.$t(
                                        "Itens por pacote de entrega"
                                      ),
                                      instruction: _vm.$t(
                                        "Quantidade de itens deste produto que cabem em um pacote de entrega."
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.product.itemsPerDeliveryPackage,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.product,
                                          "itemsPerDeliveryPackage",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "product.itemsPerDeliveryPackage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-integrate-with-beer-cooler",
                                      type: _vm.isReadOnly
                                        ? "status-badge"
                                        : "switch",
                                      "badge-type": "yesNo",
                                      label: _vm.$t("Integra Quiosque?"),
                                      instructions: [
                                        {
                                          text: _vm.$t(
                                            "ATENÇÃO: Não marque esta opção para o produto de Cartão, utilize apenas para os chopes que serão instalados nas torneiras"
                                          ),
                                        },
                                        {
                                          text: _vm.$t(
                                            "Quando selecionado, este produto é integrado para que possa ser ofertado na chopeira das lojas do tipo Quiosque"
                                          ),
                                        },
                                      ],
                                    },
                                    model: {
                                      value:
                                        _vm.product.integrateWithBeerCooler,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.product,
                                          "integrateWithBeerCooler",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "product.integrateWithBeerCooler",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-active-b2b",
                                      type: _vm.isReadOnly
                                        ? "status-badge"
                                        : "switch",
                                      "badge-type": "yesNo",
                                      label: _vm.$t("Vender no B2B?"),
                                      instruction: _vm.$t(
                                        "Quando selecionado, o produto será disponibilizado para venda B2B"
                                      ),
                                    },
                                    model: {
                                      value: _vm.product.activeB2B,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.product, "activeB2B", $$v)
                                      },
                                      expression: "product.activeB2B",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.product.activeB2B
                                ? _c(
                                    "b-col",
                                    { attrs: { md: "3" } },
                                    [
                                      _c("FormulateInput", {
                                        class: _vm.product.activeB2B
                                          ? "required"
                                          : "",
                                        attrs: {
                                          id: "product-b2b-quantity-b2b",
                                          type: _vm.isReadOnly
                                            ? "label"
                                            : "text-number",
                                          label: _vm.$t("Qtd. embalagem B2B"),
                                          instruction: _vm.$t(
                                            "Quantidade que vem na embalagem para venda B2B. Exemplo, para long neck, o pack vem com 6 unidades. Esta é a quantidade mínima na venda B2B e também o múltiplo que será usado (não será permitido quantidades quebradas, apenas múltiplos da quantidade informada neste campo)."
                                          ),
                                          validation: _vm.product.activeB2B
                                            ? "required"
                                            : "",
                                        },
                                        model: {
                                          value: _vm.product.unitsPerPackB2B,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.product,
                                              "unitsPerPackB2B",
                                              $$v
                                            )
                                          },
                                          expression: "product.unitsPerPackB2B",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "product-tags",
                                      type: _vm.isReadOnly ? "label" : "tags",
                                      label: _vm.$t("Tags"),
                                      placeholder: _vm.$t(
                                        "Digite a tag e tecle Enter"
                                      ),
                                      size: "lg",
                                      "tag-variant": "secondary",
                                      instruction: _vm.$t(
                                        "Digite a tag e tecle Enter"
                                      ),
                                      multiple: "",
                                    },
                                    model: {
                                      value: _vm.product.tags,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.product, "tags", $$v)
                                      },
                                      expression: "product.tags",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-card-actions",
                {
                  attrs: { "action-collapse": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("b-card-title", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("Configurações de Estoque")) +
                                " "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "div",
                    [
                      _c("configuration-table", {
                        attrs: { configurations: _vm.skuConfigurations },
                        on: {
                          "add-configuration": _vm.openSidebar,
                          "update-configuration": _vm.openSidebar,
                          "delete-configuration": _vm.deleteConfiguration,
                        },
                      }),
                      _c("configuration-sidebar", {
                        ref: "configurationSidebar",
                        on: {
                          create: _vm.createConfiguration,
                          update: _vm.updateConfiguration,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }